import React from 'react';
import {
  Table as VWTable,
  TableHead as VWTableHead,
  TableRow as VWTableRow,
  TableHeader as VWTableHeader,
  TableCell as VWTableCell,
  TableBody as VWTableBody,
} from '@volkswagen-onehub/components-core';
import {TableProps} from '@volkswagen-onehub/whitelabel-e-mobility-commons';
import {Text} from '../text';

export function Table(props: TableProps): JSX.Element {
  const {headers, rows, columnSizes} = props;

  return (
    <VWTable columns={columnSizes} navigation={'auto'} fixedHeaderColumn>
      <VWTableHead>
        <VWTableRow>
          <VWTableCell />
          {headers?.map((header) => (
            <VWTableCell key={header}>
              <Text variant={'copy'} bold>
                {header}
              </Text>
            </VWTableCell>
          ))}
        </VWTableRow>
      </VWTableHead>
      <VWTableBody>
        {rows?.map((row) => {
          const {header, cells} = row;
          return (
            <VWTableRow key={header}>
              <VWTableHeader emphasized>
                <Text variant={'copy'} bold>
                  {header}
                </Text>
              </VWTableHeader>
              {cells.map((cell, index) => (
                <VWTableCell key={index}>{cell}</VWTableCell>
              ))}
            </VWTableRow>
          );
        })}
      </VWTableBody>
    </VWTable>
  );
}
